import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

/** Marks a tournament Badminton Warriors sanctioned as an official BW event. */
export function OfficialBadge() {
  return (
    <Chip
      size="small"
      color="primary"
      variant="outlined"
      icon={<VerifiedRoundedIcon aria-hidden />}
      label="Official"
      title="Official BW tournament"
      sx={{ fontWeight: 700, flexShrink: 0 }}
    />
  );
}

/** What being official means for the player. */
export function OfficialRatingNote() {
  return (
    <Stack
      direction="row"
      spacing={0.75}
      sx={{ alignItems: "center", color: "text.secondary" }}
    >
      <VerifiedRoundedIcon
        sx={{ fontSize: 16, color: "primary.main" }}
        aria-hidden
      />
      <Typography variant="body2">
        Official BW tournament: results count toward your BW rating.
      </Typography>
    </Stack>
  );
}
